module.exports = __webpack_public_path__ + "img/alert-circle.3c85352a.svg";